import { css } from 'styled-components';
import { responsiveProperty } from './responsiveProperty';
export const widthPropsNames = ['width', 'minWidth', 'maxWidth'];
export const widthProps = css `
  ${(props) => props.width && responsiveProperty('width', props.width)};
  ${(props) => props.minWidth && responsiveProperty('minWidth', props.minWidth)};
  ${(props) => props.maxWidth && responsiveProperty('maxWidth', props.maxWidth)};
`;
